const DYNAMIC_IMPORT_FAILURE_PATTERN =
  /failed to fetch dynamically imported module|importing a module script failed|error loading dynamically imported module|failed to fetch module/i;

export function getErrorMessage(error: unknown): string {
  if (error instanceof Error) {
    return error.message;
  }

  if (typeof error === 'string') {
    return error;
  }

  try {
    return JSON.stringify(error);
  } catch {
    return 'Unknown application error';
  }
}

export function isDynamicImportFailure(error: unknown): boolean {
  return DYNAMIC_IMPORT_FAILURE_PATTERN.test(getErrorMessage(error));
}

export async function resetBrowserState() {
  const tasks: Promise<unknown>[] = [];

  if (typeof navigator !== 'undefined' && 'serviceWorker' in navigator) {
    tasks.push(
      navigator.serviceWorker.getRegistrations().then((registrations) =>
        Promise.all(registrations.map((registration) => registration.unregister())),
      ),
    );
  }

  if (typeof window !== 'undefined' && 'caches' in window) {
    tasks.push(
      caches.keys().then((keys) => Promise.all(keys.map((key) => caches.delete(key)))),
    );
  }

  await Promise.allSettled(tasks);
}

export async function resetBrowserStateAndReload() {
  await resetBrowserState();

  const url = new URL(window.location.href);
  url.searchParams.set('reload', Date.now().toString());
  window.location.replace(url.toString());
}
